export default __webpack_public_path__ + "static/media/lineto-circular-book.5b0e4a98.woff2";